var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$i18n.locale === 'ru')?_c('nuxt-link',{staticClass:"icon-loup",attrs:{"to":_vm.localePath('/search', _vm.$i18n.locale)}},[_c('Icon24FillSearch',{attrs:{"fill":_vm.$colors.black40}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }